module.exports = __webpack_public_path__ + "static/img/2-7.2c64d5dd.png";